import React from 'react'
import ItemTypes from '../../lib/item_types'

const I18n = window.I18n

export default class CheckboxInputSettings extends React.Component {

  onChange = (e) => {
    const { item, path, handlers } = this.props
    handlers.updateItemAttr(e, item, ItemTypes.ELEMENT.type, this.props.path)
  }

  render () {
    const { label, value } = this.props.item

    return (
      <div className="checkbox-input-settings">
        <div className="form-group">
          <label>{I18n.t('application.titles.label')}</label>
          <input type="text" className="form-control" name="label" value={label || ''} onChange={this.onChange} />
        </div>
        <div className="form-group">
          <label>{I18n.t('application.titles.value')}</label>
          <input type="text"  className="form-control" name="value" value={value || ''} onChange={this.onChange} />
        </div>
      </div>
    )
  }
}
